<template>
  <span>
    <el-dialog
    title="关闭"
    :visible.sync="analysisDetailFlag"
    append-to-body
    width="30%">
        <div>关闭详情</div>
    </el-dialog>
    <el-button icon=""
            style="padding:0 .1rem" size="small" type="text" @click="deleteAction">关闭</el-button>
  </span>
</template>

<script>
import { updateWorkStatus } from '@/api/v4ward/assess/task/assesstask';
export default {

  props: {
    query: {
      default: ()=>{}, //项目id
    },
    row: {
      default: ()=>{}, //项目id
    },
  },
    data(){
        return{
            
      analysisDetailFlag:false,
        }
    },
    methods:{
        deleteAction(){
            let row = this.row;
      this.$confirm('确定将选择数据关闭?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return updateWorkStatus({ id: row.id,workStatus:3 });
        })
        .then(() => {
            this.$emit('refreshAction');
          this.$message.success('操作成功!');
        });
        }
    }
}
</script>

<style>

</style>